/* eslint-disable @typescript-eslint/no-unused-vars */
import { ref } from 'vue'

export function useComponeRef<T extends abstract new (...args: any) => any>(
  _comp: T
) {
  return ref<InstanceType<T>>()
}
